import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "./axiosBaseQuery";
import { AuthInfo } from "../objects/authInfo";

export const commonApi = createApi({
    reducerPath: 'api.common',
    baseQuery: axiosBaseQuery({
        baseUrl: (queryParameters) => {
            if (queryParameters.v2) {
                return `${API_HREF}client/${window.id_owner}`.replace('v1', 'v2');
            }
            return `${API_HREF}client/${window.id_owner}`;
        }
    }),
    tagTypes: [
        'auth-info',
        'itinerary-content',
        'currency-rates',
        'currency-rate-history',
    ],
    endpoints: (builder) => ({
        getAuthInfo: builder.query<
            AuthInfo | null,
            void
        >({
            query: (options) => {
                return {
                    url: `/auth/info/`,
                }
            },
            providesTags: ['auth-info']
        }),
    })
});

export const {
    useGetAuthInfoQuery
} = commonApi;